/*!
ugs_web js functions
*/

const offer_module = 'unigreenscheme.unigreenscheme.doctype.offer_to_buy.offer_to_buy';


frappe.ready(function() {
    function ugs_alert_message(txt) {
        if (txt) {
            $("#contact-alert").html(txt).toggle(true);
        }
    }

    $('#offer-radio-group input').on('change', function() {
        // Hide/show offer price box
        if ($('#offer-radio-offer').prop('checked')) {
            // Show offer price box
            $('#offer-price-group').show();
        } else {
            // Hide offer price box and set to zero
            $('#offer-price-group').hide();
            $('#offer-price-group [name="offer"]').val(0);
        }
    });

    $('.ugs-currency-dropdown > a').on("click", function() {
        // Update the text and data-currency on the Offer currency selector
        const symbol = $(this).data('symbol');
        const currency = $(this).data('currency');
        const currency_button = $('.ugs-currency-button');
        currency_button.text(symbol);
        currency_button.data('currency', currency);
    });

    $('.btn-ugs-item-offer').on("click", function() {
        const item_code = $('[itemprop="productID"]').text();
        const email = $('[name="email"]').val();
        const name = $('[name="name"]').val();
        const company = $('[name="company"]').val();
        const offer = $('[name="offer"]').val();
        const currency = $('.ugs-currency-button').data('currency');
        const country = $('[name="country"]').val();
        const message = $('[name="message"]').val();
        const need_shipping_quote = $('[id="offer-checkbox-shipping"]').prop('checked');
        const own_shipping = $('[id="offer-checkbox-own-shipping"]').prop('checked');

        if (!(email && name && country)) {
            ugs_alert_message(
                "Please enter your email, name and country \
                so that we can get back to you."
            );
            return false;
        }

        if (isNaN(offer)) {
            ugs_alert_message(
                "Please enter a valid offer price \
                (numbers only please)."
            );
            $('[name="offer"]').focus();
            return false;
        }

        if (!validate_email(email)) {
            ugs_alert_message(
                "Please enter a valid email address so that we can get back \
                to you."
            );
            $('[name="email"]').focus();
            return false;
        }

        const countries = $('#ugsCountryList').children().map(function() {
            return this.innerText}
        ).get()

        if (!countries.includes(country)) {
            ugs_alert_message(
                "Please enter a valid country"
            );
            $('[name="country"]').focus();
            return false;
        }

        $("#contact-alert").toggle(false);

        frappe.call({
            method: offer_module + ".create_offer",
            args: {
                email_id: email,
                item_code: item_code,
                offer_price: offer,
                currency: currency,
                country: country,
                customer_message: message,
                customer_name: name,
                customer_company: company,
                need_shipping_quote: need_shipping_quote ? 1 : 0,
                own_shipping: own_shipping ? 1 : 0
            }
        }).then(() => {
            // Success (no exception raised)
            if (offer && offer != '0') {
                ugs_alert_message(
                    `<span id="ugs-offer-submitted-span">
                        Your offer has been submitted.
                    </span>`
                );
                $('#ugs-offer-submitted-span').attr({
                    "data-email": email,
                    "data-item-code": item_code,
                    "data-offer-price": offer,
                    "data-currency": currency,
                    "data-country": country,
                    "data-need-shipping-quote": need_shipping_quote,
                    "data-own-shipping": own_shipping
                });
            } else {
                ugs_alert_message(
                    `<span id="ugs-request-submitted-span">
                        Your request has been submitted.
                    </span>`
                );
                $('#ugs-request-submitted-span').attr({
                    "data-email": email,
                    "data-item-code": item_code,
                    "data-country": country,
                    "data-need-shipping-quote": need_shipping_quote,
                    "data-own-shipping": own_shipping
                });
            }
            $('.ugs-offer-card :input').val('');
            $('.ugs-offer-card :checkbox').prop('checked', false);
        });
    });

});
